import { Formik } from 'formik'
import React, { useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { initialValues } from '../../profile/core/_constants'
import TextArea from '../../widgets/components/Input/TextArea'
import ReCAPTCHA from 'react-google-recaptcha'

const ConnectWithCofounderModal = ({ isModalActive, setIsModalActive }: any) => {

    const { formatMessage } = useIntl()
    const [recaptchaToken, setRecaptchaToken] = useState(null)
    const onRecaptchaChange = (token: any) => {
        setRecaptchaToken(token)
    }

    const handleSubmit = async (values: any, { resetForm }: any) => {
        if (!recaptchaToken) {
            alert('Please complete the reCAPTCHA')
            return
        }
        // Submit form data
    }
    return (
        <div>
            <script src="https://www.google.com/recaptcha/api.js" async defer></script>
            <Modal
                show={isModalActive}
                onHide={() => {
                    setIsModalActive(false)
                }}
                size='lg'
            >
                <Modal.Header closeButton>
                    <div className="d-flex flex-column">
                        <h2>{formatMessage({ id: 'Co-Founder Details' })}</h2>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='w-100 container'>
                        <Formik
                            initialValues={initialValues}
                            validationSchema={{}}
                            onSubmit={handleSubmit}
                        >
                            {(formik) => (
                                <Form>
                                    <div className='row'>
                                        <div className='col-md-12 col-12'>
                                            <TextArea
                                                label={formatMessage({ id: 'Experience' })}
                                                fieldName='Expirence'
                                                formik={formik}
                                                placeholder={formatMessage({ id: 'Enter Years of Experience*' })}
                                                toolTipText={formatMessage({
                                                    id: 'Write a message that you would like to convey to the founder(s) of the company that you are applying for the post of co-founder.',
                                                })}
                                                isStarRequired={true}
                                                isTooltipForModal={true}
                                            />
                                        </div>

                                        {/* Google reCAPTCHA */}
                                        <div className="my-3">
                                            <ReCAPTCHA
                                                sitekey="6Ld3dF4qAAAAAOdLVqLDUbhZljzSn4JEayZEyWmk" // Replace with your site key
                                                onChange={onRecaptchaChange}
                                            />
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                        {/* Success Message */}
                        {/* <div className='d-flex flex-column align-items-center justify-content-center gap-4'>
                            <i className="fa-regular fa-circle-check text-success" style={{ fontSize: '72px' }}></i>
                            <p className='fw-semibold font-size-14'>{formatMessage({ id: `Your message has been sent to {Company-name}. You will get a response soon` })}</p>
                        </div> */}

                        {/* Fail Message */}
                        {/* <div className='d-flex flex-column align-items-center justify-content-center gap-4'>
                            <i className="fa-regular fa-circle-xmark text-danger" style={{ fontSize: '72px' }}></i>
                            <p className='fw-semibold font-size-14'>{formatMessage({ id: `Oops! There was an error sending your message. Please try again later.` })}</p>
                        </div> */}

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-md-flex w-100 w-md-auto justify-content-end px-md-6 px-0 gap-3'>
                        <div className='w-100 order-1 order-md-2 mb-2 mb-md-auto'>
                            <button type='submit' className=' btn btn-primary w-100'>
                                {formatMessage({ id: 'Submit' })}
                            </button>
                        </div>
                        <div className='w-100 w-md-auto order-2 order-md-1 '>
                            <button type='button' className='btn btn-light text-muted w-100'>
                                {formatMessage({ id: 'Cancel' })}
                            </button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ConnectWithCofounderModal
